const stripTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

export const API_BASE_URL = stripTrailingSlash(
  process.env.REACT_APP_API_BASE_URL || 'https://api.bmsdhealthcare.com'
);

export const API_PREFIX = `${API_BASE_URL}/api`;
export const APP_NAME = process.env.REACT_APP_NAME || 'BMSD Admin';
export const WEBSITE_BASE_URL = stripTrailingSlash(
  process.env.REACT_APP_WEBSITE_BASE_URL || 'https://www.bmsdhealthcare.com'
);
